export default __webpack_public_path__ + "static/media/days_availability.bf5b7d44.webp";